export default __webpack_public_path__ + "static/systemIntegrationAutomation-3539689598fc776762a79e379ac9d545.jpg";